var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "more-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 8.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 15.5,
    cy: 1.5,
    r: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(13.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FE5620",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#2E2B2B",
    strokeWidth: 1,
    cx: 1.5,
    cy: 1.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.5,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeLinejoin: "square",
    cx: 1.5,
    cy: 1.5,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FE5620",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#2E2B2B",
    strokeWidth: 1,
    cx: 8.5,
    cy: 1.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.5,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeLinejoin: "square",
    cx: 8.5,
    cy: 1.5,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FE5620",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#2E2B2B",
    strokeWidth: 1,
    cx: 15.5,
    cy: 1.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.5,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeLinejoin: "square",
    cx: 15.5,
    cy: 1.5,
    r: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreActive);
export default __webpack_public_path__ + "static/media/more-active.f17090f90942d5694ba400c5fa314e75.svg";
export { ForwardRef as ReactComponent };